module.exports = __webpack_public_path__ + "img/ide-geometric.7fc50e45.svg";